export const LANGUAGES_DICT = {
  sr: "Serbian",
  ro: "Romanian, Moldavian, Moldovan",
  ii: "Sichuan Yi, Nuosu",
  ty: "Tahitian",
  tl: "Tagalog",
  yi: "Yiddish",
  ak: "Akan",
  ms: "Malay",
  ar: "Arabic",
  no: "Norwegian",
  oj: "Ojibwa",
  ff: "Fulah",
  fa: "Persian",
  sq: "Albanian",
  ay: "Aymara",
  az: "Azerbaijani",
  zh: "Chinese",
  cr: "Cree",
  et: "Estonian",
  gn: "Guaraní",
  ik: "Inupiaq",
  iu: "Inuktitut",
  kr: "Kanuri",
  kv: "Komi",
  kg: "Kongo",
  ku: "Kurdish",
  lv: "Latvian",
  mg: "Malagasy",
  mn: "Mongolian",
  om: "Oromo",
  ps: "Pashto, Pushto",
  qu: "Quechua",
  sc: "Sardinian",
  sw: "Swahili",
  uz: "Uzbek",
  za: "Zhuang, Chuang",
  bi: "Bislama",
  nb: "Norwegian Bokmål",
  nn: "Norwegian Nynorsk",
  id: "Indonesian",
  tw: "Twi",
  eo: "Esperanto",
  ia: "Interlingua",
  ie: "Interlingue",
  io: "Ido",
  vo: "Volapük",
  bh: "Bihari languages",
  he: "Hebrew (modern)",
  sa: "Sanskrit",
  cu: "Church Slavic, Church Slavonic, Old Church Slavonic, Old Slavonic, Old Bulgarian",
  pi: "Pali",
  ae: "Avestan",
  la: "Latin",
  hy: "Armenian",
  ss: "Swati",
  bo: "Tibetan",
  nr: "South Ndebele",
  sl: "Slovene",
  or: "Oriya",
  nd: "North Ndebele",
  na: "Nauru",
  mi: "Maori",
  mr: "Marathi",
  lu: "Luba-Katanga",
  rn: "Rundi",
  km: "Central Khmer",
  fy: "Western Frisian",
  bn: "Bengali",
  av: "Avaric",
  ab: "Abkhazian",
  aa: "Afar",
  af: "Afrikaans",
  am: "Amharic",
  an: "Aragonese",
  as: "Assamese",
  bm: "Bambara",
  ba: "Bashkir",
  eu: "Basque",
  be: "Belarusian",
  bs: "Bosnian",
  br: "Breton",
  bg: "Bulgarian",
  my: "Burmese",
  ca: "Catalan, Valencian",
  ch: "Chamorro",
  ce: "Chechen",
  ny: "Chichewa, Chewa, Nyanja",
  cv: "Chuvash",
  kw: "Cornish",
  co: "Corsican",
  hr: "Croatian",
  cs: "Czech",
  da: "Danish",
  dv: "Divehi, Dhivehi, Maldivian",
  nl: "Dutch, Flemish",
  dz: "Dzongkha",
  en: "English",
  ee: "Ewe",
  fo: "Faroese",
  fj: "Fijian",
  fi: "Finnish",
  fr: "French",
  gl: "Galician",
  ka: "Georgian",
  de: "German",
  el: "Greek (modern)",
  gu: "Gujarati",
  ht: "Haitian, Haitian Creole",
  ha: "Hausa",
  hz: "Herero",
  hi: "Hindi",
  ho: "Hiri Motu",
  hu: "Hungarian",
  ga: "Irish",
  ig: "Igbo",
  is: "Icelandic",
  it: "Italian",
  ja: "Japanese",
  jv: "Javanese",
  kl: "Kalaallisut, Greenlandic",
  kn: "Kannada",
  ks: "Kashmiri",
  kk: "Kazakh",
  ki: "Kikuyu, Gikuyu",
  rw: "Kinyarwanda",
  ky: "Kirghiz, Kyrgyz",
  ko: "Korean",
  kj: "Kuanyama, Kwanyama",
  lb: "Luxembourgish, Letzeburgesch",
  lg: "Ganda",
  li: "Limburgan, Limburger, Limburgish",
  ln: "Lingala",
  lo: "Lao",
  lt: "Lithuanian",
  gv: "Manx",
  mk: "Macedonian",
  ml: "Malayalam",
  mt: "Maltese",
  mh: "Marshallese",
  nv: "Navajo, Navaho",
  ne: "Nepali",
  ng: "Ndonga",
  oc: "Occitan",
  os: "Ossetian, Ossetic",
  pa: "Panjabi, Punjabi",
  pl: "Polish",
  pt: "Portuguese",
  rm: "Romansh",
  ru: "Russian",
  sd: "Sindhi",
  se: "Northern Sami",
  sm: "Samoan",
  sg: "Sango",
  gd: "Gaelic, Scottish Gaelic",
  sn: "Shona",
  si: "Sinhala, Sinhalese",
  sk: "Slovak",
  so: "Somali",
  st: "Southern Sotho",
  es: "Spanish, Castilian",
  su: "Sundanese",
  sv: "Swedish",
  ta: "Tamil",
  te: "Telugu",
  tg: "Tajik",
  th: "Thai",
  ti: "Tigrinya",
  tk: "Turkmen",
  tn: "Tswana",
  to: "Tongan (Tonga Islands)",
  tr: "Turkish",
  ts: "Tsonga",
  tt: "Tatar",
  ug: "Uighur, Uyghur",
  uk: "Ukrainian",
  ur: "Urdu",
  ve: "Venda",
  vi: "Vietnamese",
  wa: "Walloon",
  cy: "Welsh",
  wo: "Wolof",
  xh: "Xhosa",
  yo: "Yoruba",
  zu: "Zulu",
};
